import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

interface IndicationNumberProps {
  value:
    | number
    | {
        customComponent: React.ReactNode;
        shouldShow: boolean;
      };
}

export const IndicationNumber = ({ value = 0 }: IndicationNumberProps) => {
  const displayValue =
    typeof value === 'number' ? value : value.customComponent;
  const shouldShow = typeof value === 'number' ? value > 0 : value.shouldShow;
  return (
    <Box
      position="absolute"
      left="50%"
      justifyContent="center"
      alignItems="center"
      bg="primary"
      borderRadius="full"
      py="space1"
      px="space2"
      extend={({ theme }) => ({
        opacity: shouldShow ? 1 : 0,
        minWidth: `${theme.fontSizes[3]}px`,
        whiteSpace: 'nowrap',
        transform: 'translateX(-50%) translateY(-125%)',
        transition: `opacity ${theme.durations[1]}s ease`,
      })}
    >
      <Text lineHeight="none" color="onPrimary" fontSize={1}>
        {displayValue}
      </Text>
    </Box>
  );
};
